// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/css/bootstrap.min.css
// module id = 2257
// module chunks = 5